import { Injectable } from '@angular/core';
import { captureException } from '@sentry/angular';
import type { Extras } from '@sentry/core';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {

  public logError(error: Error, extras?: Extras): void {
    console.error(error);
    captureException(error, (scope) => {
      if (extras) {
        scope.setExtras(extras);
      }
      return scope;
    });
  }
}
